<template>
	<b-carousel
		id="carousel-fade"
		indicators
		:controls="true"
		:interval="10000"
	>
		<b-carousel-slide
			v-for="photo in photos"
			:key="photo.idgaleria"
			caption
		>
			<template #img>
				<img
					class="image-carousel"
					:src="photoUrl(photo)"
					alt="image slot"
					:id="photo.idgaleria"
				/>
			</template>
		</b-carousel-slide>
	</b-carousel>
</template>

<script>
export default {
	name: "CarouselAdmin",
    props: ["photos", "idAlojamiento", "externalReference"],
	data() {
        return {
            url: process.env.VUE_APP_S3_URL
        }
    },
    methods: {
        photoUrl(photo) {
            const rawUrl = photo && photo.url ? photo.url : '';
            const finalUrl = this.externalReference ? rawUrl : this.normalizeS3ImageUrl(rawUrl);

            return finalUrl;
        },
        normalizeS3ImageUrl(url) {
            if (!url) return '';

            const bucket = (process.env.VUE_APP_AWS_BUCKET_URL || '').replace(/^\/+|\/+$/g, '');
            if (url.indexOf('http') === -1) {
                return this.url + url;
            }

            if (!bucket || url.indexOf('s3-sa-east-1.amazonaws.com') === -1 || url.indexOf(bucket) > -1) {
                return url;
            }

            try {
                const parsedUrl = new URL(url);
                parsedUrl.pathname = `/${bucket}/${parsedUrl.pathname.replace(/^\/+/, '')}`;
                return parsedUrl.toString();
            } catch (e) {
                return url;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.image-carousel {
	width: 100%;
    height: 100%;
}

#carousel-fade {
	width: 100%;
	height: 100%;
}
</style>
